
import { useTranslation } from 'react-i18next';

export default function UrgencySection() {
  const { t } = useTranslation();

  const handleClick = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-16 bg-gradient-to-br from-[#7A1A28] via-[#9B2335] to-[#7A1A28] relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-32 h-32 border-2 border-[#C8960C] rounded-full"></div>
        <div className="absolute bottom-10 right-10 w-40 h-40 border-2 border-[#C8960C] rounded-full"></div>
        <div className="absolute top-1/2 left-1/4 w-24 h-24 border-2 border-[#F5E6C8] rounded-full"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center">
          <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6">
            <div
              className="w-full h-full rounded-full flex items-center justify-center"
              style={{
                background: 'linear-gradient(135deg, rgba(200, 150, 12, 0.3) 0%, rgba(245, 230, 200, 0.2) 100%)',
                border: '2px solid rgba(200, 150, 12, 0.5)',
              }}
            >
              <i className="ri-alarm-warning-line text-3xl text-[#F5E6C8]"></i>
            </div>
          </div>

          <h2
            className="text-3xl md:text-4xl font-bold mb-6"
            style={{
              color: '#F5E6C8',
              fontFamily: "'Noto Serif JP', serif",
            }}
          >
            {t('common:urgency.title')}
          </h2>

          <p
            className="text-lg md:text-xl mb-8 leading-relaxed max-w-2xl mx-auto"
            style={{ color: '#EDD9A3' }}
          >
            {t('common:urgency.description')}
          </p>

          <button
            onClick={handleClick}
            className="px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 cursor-pointer whitespace-nowrap hover:scale-105 hover:shadow-2xl"
            style={{
              background: 'linear-gradient(135deg, #C8960C 0%, #B8860B 100%)',
              color: '#1A1A1A',
              border: '2px solid rgba(245, 230, 200, 0.3)',
              fontFamily: "'Noto Serif JP', serif",
            }}
          >
            <span className="flex items-center gap-3">
              <i className="ri-calendar-check-line text-xl"></i>
              {t('common:urgency.ctaButton')}
            </span>
          </button>

          <p className="mt-6 text-sm" style={{ color: '#F5E6C8', opacity: 0.8 }}>
            <i className="ri-time-line mr-2"></i>
            {t('common:urgency.note')}
          </p>
        </div>
      </div>

      <div
        className="absolute top-4 left-4 w-8 h-8 border-t-2 border-l-2"
        style={{ borderColor: '#C8960C', opacity: 0.4 }}
      />
      <div
        className="absolute bottom-4 right-4 w-8 h-8 border-b-2 border-r-2"
        style={{ borderColor: '#C8960C', opacity: 0.4 }}
      />
    </section>
  );
}
